import {
  type GLTF,
  GLTFLoader
} from "three/examples/jsm/loaders/GLTFLoader.js";

const loader = new GLTFLoader();

export function loadGltf(url: string): Promise<GLTF> {
  return loader.loadAsync(url);
}
